import { useEffect, useState } from "react";
import routeApi from "modules/client/routes/store/api";

export const DRIVER_LOCATION_POLL_MS = 10000;

export function toDriverPosition(location) {
  if (
    !location ||
    typeof location.latitude !== "number" ||
    typeof location.longitude !== "number"
  )
    return null;
  return {
    lat: location.latitude,
    lng: location.longitude,
    recordedAt: location.recordedAt
  };
}

/**
 * Polls `fetchLocation` and returns the latest `{ lat, lng, recordedAt }`, or null.
 * The returned object only changes when the reported fix changes.
 */
export function usePolledDriverLocation(fetchLocation, key) {
  const [currentDriver, setCurrentDriver] = useState(null);

  useEffect(() => {
    setCurrentDriver(null);
    if (!key) return;
    let cancelled = false;

    const load = () =>
      fetchLocation(key)
        .then((location) => {
          if (cancelled) return;
          const next = toDriverPosition(location);
          setCurrentDriver((prev) =>
            prev &&
            next &&
            prev.lat === next.lat &&
            prev.lng === next.lng &&
            prev.recordedAt === next.recordedAt
              ? prev
              : next
          );
        })
        .catch(() => {});

    load();
    const timer = setInterval(load, DRIVER_LOCATION_POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return currentDriver;
}

export function useDriverLocationByRoute(routeId) {
  return usePolledDriverLocation(routeApi.getDriverLocation, routeId);
}
